import { NgModuleFactory, Type, Compiler, NgModuleRef, NgModuleFactoryLoader, Injector } from '@angular/core';
import { of, from, isObservable, throwError } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
var ModuleLoaderService = /** @class */ (function () {
    function ModuleLoaderService(injector, compiler, moduleLoader) {
        this.injector = injector;
        this.compiler = compiler;
        this.moduleLoader = moduleLoader;
        this._registry = new Map();
        this._cache = new Map();
    }
    ModuleLoaderService.prototype.register = function (moduleLoaderDefs) {
        var _this = this;
        moduleLoaderDefs.forEach(function (value) {
            _this._registry.set(value.name, value);
        });
    };
    ModuleLoaderService.prototype.getOrLoad = function (moduleDef, localInjector) {
        var _this = this;
        if (typeof moduleDef !== 'string' && moduleDef.componentFactoryResolver != null) {
            return of(moduleDef);
        }
        var name = this.getName(moduleDef);
        var moduleReference = this._cache.get(name);
        if (moduleReference != null) {
            return isObservable(moduleReference)
                ? moduleReference
                : of(moduleReference);
        }
        var result;
        if (typeof moduleDef === 'string') {
            var registryValue = this._registry.get(moduleDef);
            if (registryValue == null) {
                return throwError("No NgModule module loader specified for '" + moduleDef + "'");
            }
            result = from(registryValue.load())
                .pipe(tap(function (_) { return console.log('NgModule loaded', name); }), map(function (moduleOrFactory) {
                if (moduleOrFactory instanceof NgModuleFactory) {
                    return moduleOrFactory;
                }
                return _this.compiler.compileModuleAsync(moduleOrFactory);
            }), map(function (factory) {
                var ngModuleRef = factory.create(localInjector || _this.injector);
                _this._cache.set(name, ngModuleRef);
                console.log('ngModule created', name);
                return ngModuleRef;
            }), shareReplay(1));
        }
        else {
            var pathAndModule = moduleDef['path'] + "#" + moduleDef['name'];
            result = from(this.moduleLoader.load(pathAndModule))
                .pipe(map(function (factory) {
                var ngModuleRef = factory.create(localInjector || _this.injector);
                _this._cache.set(name, ngModuleRef);
                return ngModuleRef;
            }), shareReplay(1));
        }
        this._cache.set(name, result);
        return result;
    };
    ModuleLoaderService.prototype.getName = function (moduleDef) {
        if (typeof moduleDef === 'string') {
            return moduleDef;
        }
        else {
            return moduleDef['name'];
        }
    };
    ModuleLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModuleLoaderService_Factory() { return new ModuleLoaderService(i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(i0.Compiler), i0.ɵɵinject(i0.NgModuleFactoryLoader)); }, token: ModuleLoaderService, providedIn: "root" });
    return ModuleLoaderService;
}());
export { ModuleLoaderService };
